/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelGetVoucherByDatePost } from '../fn/get-voucher-info-by-date-endpoint/api-hotel-get-voucher-by-date-post';
import { ApiHotelGetVoucherByDatePost$Params } from '../fn/get-voucher-info-by-date-endpoint/api-hotel-get-voucher-by-date-post';
import { GetVoucherResponseInfoArrayResultApiResult } from '../models/get-voucher-response-info-array-result-api-result';

@Injectable({ providedIn: 'root' })
export class GetVoucherInfoByDateEndpointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHotelGetVoucherByDatePost()` */
  static readonly ApiHotelGetVoucherByDatePostPath = '/api/hotel/GetVoucherByDate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelGetVoucherByDatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelGetVoucherByDatePost$Response(params: ApiHotelGetVoucherByDatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVoucherResponseInfoArrayResultApiResult>> {
    return apiHotelGetVoucherByDatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelGetVoucherByDatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelGetVoucherByDatePost(params: ApiHotelGetVoucherByDatePost$Params, context?: HttpContext): Observable<GetVoucherResponseInfoArrayResultApiResult> {
    return this.apiHotelGetVoucherByDatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetVoucherResponseInfoArrayResultApiResult>): GetVoucherResponseInfoArrayResultApiResult => r.body)
    );
  }

}
